import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, concatMap, delay, retryWhen } from 'rxjs/operators';
import { env } from '../../../app.constant';
import { AuthService } from '../../mock/system/auth.service';
import { SessionService } from '../../mock/system/session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private is_get_session: boolean = false;

    constructor(
        private cookie: CookieService,
        private router: Router,
        private authService: AuthService,
        private sessionService: SessionService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const time = new Date().getTime();
        const exp_date = Number(this.cookie.get('expiration'));

        const diff = (exp_date - time) / 1000 / 60;

        if ((diff < 30 && diff >= 0) && !this.is_get_session) {
            this.is_get_session = true;
            console.log(`request new token`);
            this.authService.getNewSession().subscribe((response: any) => {
                if (Number(response.code) === 1) {
                    let now = new Date();
                    now.setHours(now.getHours() + env.token_hours_expiration);
                    // now.setMinutes(now.getMinutes() + env.token_hours_expiration);
                    this.cookie.set('AuthToken', response.message.access_token, { expires: now, secure: env.secure, sameSite: 'Strict' });
                    this.cookie.set('expiration', now.getTime().toString());
                }
                this.is_get_session = false;
            });
        }

        let token = this.cookie.get('AuthToken');
        if (token) {
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(req).pipe(
            catchError((e: HttpErrorResponse) => {
                if (e.status === 401) {
                    if (this.is_get_session) {
                        let token = this.cookie.get('AuthToken');
                        if (token) {
                            req = req.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${token}`
                                }
                            });
                        }
                        return next.handle(req);
                    }
                    this.sessionService.deleteUserSession();
                    this.cookie.delete('AuthToken');
                    this.cookie.delete('expiration');
                    this.router.navigate(["/public"]);
                    // return throwError(() => "Unauthorized.");
                    return throwError(e);
                } else {
                    return throwError(e);
                }
            })
        );

    }

}

